/* Manu AI v10 (16/10/2026)
 * - Mobile : la carte Manu (idée · sport · style · Créer · exemples) rejoint le titre et l'accroche en bas de la vidéo hero
 *   (bloc « Hero video mobile »). ai-studio.js y pose déjà l'intro ; ici on y ajoute le formulaire, et on le remet en place sur ordinateur.
 * - « Choisis pour moi » : le libellé réglé dans l'éditeur l'emporte sur celui renvoyé par l'API des styles.
 * S'appuie sur l'instance de assets/ai-studio.js (section._ais), enrichie par assets/ai-studio-v9.js, tous deux chargés avant. */
(function () {
  function enhance(root) {
    var inst = root._ais;
    if (!inst || inst._v10) return;
    inst._v10 = true;
    var t = inst.t || {};

    var loadStyles = inst.loadStyles;
    inst.loadStyles = function () {
      return loadStyles.apply(this, arguments).then(function (d) {
        if (d && t.style_any) { d.ui = d.ui || {}; d.ui.any = t.style_any; }
        return d;
      });
    };

    // L'intro est peut-être déjà sortie de la section (posée dans la vidéo par ai-studio.js) : on la retrouve par son titre
    var titleEl = document.getElementById(root.getAttribute('aria-labelledby') || '');
    var intro = root.querySelector('[data-ais-intro]') || (titleEl && titleEl.closest('[data-ais-intro]')), form = inst.form;
    if (!intro || !form) return;
    var home = document.createElement('div'); home.hidden = true;
    form.parentNode.insertBefore(home, form);
    var place = function () {
      var inVideo = intro.classList.contains('ais-intro--video') && intro.parentNode && !root.contains(intro);
      if (inVideo && form.parentNode !== intro) { intro.appendChild(form); intro.classList.add('ais-intro--form'); }
      else if (!inVideo && form.parentNode === intro) { home.parentNode.insertBefore(form, home); intro.classList.remove('ais-intro--form'); }
    };
    place();
    // Même requête que ai-studio.js, créée après : son écouteur (qui déplace l'intro) passe avant celui-ci
    var mq = window.matchMedia('(max-width: 749px)');
    if (mq.addEventListener) mq.addEventListener('change', place); else if (mq.addListener) mq.addListener(place);

    // Formulaire sorti de la section : ses boutons de sport ne sont plus trouvés depuis la section, on les tient à jour ici
    var setNiche = inst.setNiche;
    inst.setNiche = function () {
      setNiche.apply(this, arguments);
      if (form.parentNode !== intro) return;
      var k = this.heroNiche;
      form.querySelectorAll('[data-niche]').forEach(function (b) { b.setAttribute('aria-pressed', (b.getAttribute('data-niche') || null) === k ? 'true' : 'false'); });
    };
    // Bouton flottant et « Recommencer » : retour au champ, là où il est (dans la vidéo sur mobile)
    var toHero = inst.toHero;
    inst.toHero = function () {
      if (form.parentNode !== intro || !this.ideaField) return toHero.apply(this, arguments);
      var f = this.ideaField;
      form.scrollIntoView({ behavior: this.reduce ? 'auto' : 'smooth', block: 'center' });
      setTimeout(function () { f.focus({ preventScroll: true }); }, 400);
    };
  }

  function boot() { document.querySelectorAll('[data-ais]').forEach(enhance); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  // Éditeur de thème : la section est re-rendue, l'ancienne intro (et le formulaire) posée dans la vidéo est retirée
  document.addEventListener('shopify:section:unload', function (e) {
    if (!e.target || !e.target.querySelector || !e.target.querySelector('[data-ais]')) return;
    document.querySelectorAll('.ais-intro--video').forEach(function (el) {
      var hero = el.parentNode; el.remove();
      if (hero && hero.classList) hero.classList.remove('ais-in-video');
    });
  });
  document.addEventListener('shopify:section:load', function () { setTimeout(boot, 0); });
})();

/* 20/10/2026 — « Continuer la personnalisation » (data-act=handoff) : la couleur choisie à l'étape 2 de Manu (inst.s.color)
 * est rangée en sessionStorage rxStudioColor { k, n, at } ; assets/ai-studio-handoff.js bascule alors la fiche produit
 * sur la variante de cette couleur (mêmes autres options) avant de déposer le logo. */
(function () {
  var FR = { black: 'noir', white: 'blanc', grey: 'gris', gray: 'gris', navy: 'bleu marine', blue: 'bleu', red: 'rouge', green: 'vert', pink: 'rose', sand: 'sable', khaki: 'kaki', yellow: 'jaune', orange: 'orange', purple: 'violet', beige: 'beige' };
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-act="handoff"]'); if (!b) return;
    var root = b.closest('[data-ais]') || document.querySelector('[data-ais]'), s = root && root._ais && root._ais.s, c = s && s.color;
    if (!c) return;
    var o = typeof c === 'object' ? c : { k: c };
    var k = o.k || o.key || o.value || o.id || o.name || '', n = o.n || o.name || o.label || o.title || '';
    if (!n) n = FR[String(k).toLowerCase()] || '';
    try { sessionStorage.setItem('rxStudioColor', JSON.stringify({ k: String(k), n: String(n), at: Date.now() })); } catch (err) {}
  }, true);
})();
